export default "__VITE_ASSET__BUwC_bKE__"